import request from 'utils/request'

/*---------  密码重置    -------*/

//获取用户列表
export const getBusinessTableData = data => request().post('user/page', data)
//密码重置
export const resetPassword = id => request().get(`user/password/reset/${id}`)
